import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "smstemplate" }
const _hoisted_2 = { class: "form-group row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Title", -1)
const _hoisted_4 = { class: "col-sm-9" }
const _hoisted_5 = { class: "form-group row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Report type", -1)
const _hoisted_7 = { class: "col-sm-4" }
const _hoisted_8 = { class: "form-group row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Target", -1)
const _hoisted_10 = { class: "col-sm-4" }
const _hoisted_11 = { class: "form-group row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Chron order", -1)
const _hoisted_13 = { class: "col-sm-4" }
const _hoisted_14 = { class: "form-group row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "To be sent before (in days)", -1)
const _hoisted_16 = { class: "col-sm-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 text-right col-form-label" }, "Managed/Non-managed", -1)
const _hoisted_18 = { class: "col-sm-2" }
const _hoisted_19 = { class: "col-sm-2" }
const _hoisted_20 = { class: "dx-field" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Default", -1)
const _hoisted_22 = { class: "dx-field-value" }
const _hoisted_23 = { class: "form-group row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Message", -1)
const _hoisted_25 = { class: "col-sm-9 body-editor" }

import { computed, onMounted, ref, inject } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { SMSTemplate, Dictionary } from "@/models";
import Editor from "ckeditor5/ckeditor";
import { DxSwitch} from 'devextreme-vue/switch';


export default /*#__PURE__*/_defineComponent({
  __name: 'SMSTemplateDetails',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();

const actProperty: any = inject('actProperty');

// State and Getters
const dictionary = computed((): Dictionary => store.getters['dictionary/current'] as Dictionary);
const smstemplate = computed(() => store.getters['smstemplates/current'] as SMSTemplate);

const setSMSTemplate = (smstemplate: SMSTemplate): void => {
  store.commit('smstemplate/setSMSTemplate', smstemplate);
};


const setSMSTemplateDeep = (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('smstemplates/setSMSTemplateDeep', payload);
};


const addReporttype = (reporttype: string): Promise<any> => {
  return store.dispatch('smstemplates/addReporttype', reporttype);
};

const setReporttypes = (reporttypes: string[]): Promise<any> => {
  return store.dispatch('smstemplates/setReporttypes', reporttypes);
};
// Mounted lifecycle hook
onMounted(async () => {
  if (isNewTemplate()) {
    setSMSTemplate(new SMSTemplate());
    return;
  }
});

const bodyeditor = computed(() => {
  return Editor;
});

const bodyEditorConfig = computed(() => {
  return {
    placeholderConfig: {
      types: [
        "Access Branch",
        "Address",
        "Appointment time",
        "Booked with name",
        "Branch",
        "Client",
        "Date",
        "End time",
        "Invoice amount",
        "Landlord name",
        "Start time",
        "Tenant name",
        "Type of job external"
      ],
    },
    toolbar: {
      items: ["placeholder"],
    },
  };
});

const title = computed({
  get: () => smstemplate.value.title,
  set: (data: string) => {
    setSMSTemplateDeep({
      path: 'title',
      data,
    });
  }
});

const body = computed({
  get: () => smstemplate.value.body,
  set: (data: string) => setSMSTemplateDeep({ path: 'body', data })
});

const reporttypes = computed({
  get: () => smstemplate.value.reporttypes,
  set: (types: string[]) => {
    setReporttypes(types);
  }
});
const onSelectReporttype = (type: string) => {
  addReporttype(type);
}

const managedtypeOptions: string[] = ["Managed", "Non-managed"];
const managedtype = computed({
  get: () => smstemplate.value.managedtype,
  set: (data: string) => {
    setSMSTemplateDeep({
      path: 'managedtype',
      data,
    });
  }
});

const defaulttemplate = computed({
  get: () => smstemplate.value.defaulttemplate,
  set: (data: boolean) => {
    setSMSTemplateDeep({
      path: 'defaulttemplate',
      data,
    });
  }
});

const editTemplate = (field: string, $event: any) => {
  setSMSTemplateDeep({
    path: field,
    data: $event.target.value,
  });
};

const reportTypes = computed((): string[] => {
  let list = ["inventory", "soc", "checkin", "checkout", "property visit"];
  if (dictionary.value && dictionary.value.reporttypes) {
    list = dictionary.value.reporttypes.map((t) => t.slug);
  }
  return list;
});

const targetList: string[] = ["Tenant"];
const chronorderList: string[] = [
  "Initial confirmation",
  "First Chaser",
  "Second Chaser",
  "Third Chaser",
  "Fourth Chaser",
  "Fifth Chaser",
  "Sixth Chaser",
  "Last Minute",
  "Reminder",
  "Confirmed",
  "Not Confirmed",
];

const formatReportType = (type: string) => {
  return actProperty.formatReportType(type, dictionary.value);
}

const target = computed({
  get: () => smstemplate.value.target,
  set: (data: string[]) => store.dispatch('smstemplates/setSMSTemplateDeep', { path: 'target', data })
});
const onSelectTarget = (type: string) => {
  store.dispatch('smstemplates/addTarget', type);
};

const chronorder = computed({
  get: () => smstemplate.value.chronorder,
  set: (data: string[]) => store.dispatch('smstemplates/setSMSTemplateDeep', { path: 'chronorder', data })
});
const onSelectChronorder = (type: string) => {
  store.dispatch('smstemplates/addChronorder', type);
};

const daysbefore = computed({
  get: () => smstemplate.value.daysbefore,
  set: (data: number) => store.dispatch('smstemplates/setSMSTemplateDeep', { path: 'daysbefore', data })
});

const isNewTemplate = () => {
  return (route.params.id as string) == "new";
}


return (_ctx: any,_cache: any) => {
  const _component_multiselect_text = _resolveComponent("multiselect-text")!
  const _component_singleselect_text = _resolveComponent("singleselect-text")!
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("fieldset", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event))
          }, null, 512), [
            [_vModelText, title.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_multiselect_text, {
            modelValue: reporttypes.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((reporttypes).value = $event)),
            options: reportTypes.value,
            "allow-empty": true,
            taggable: false,
            "custom-label": formatReportType,
            multiple: "",
            onSelect: onSelectReporttype,
            onChange: _cache[2] || (_cache[2] = ($event: any) => (editTemplate('type', $event)))
          }, null, 8, ["modelValue", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_multiselect_text, {
            modelValue: target.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((target).value = $event)),
            options: targetList,
            "allow-empty": true,
            taggable: false,
            multiple: "",
            onSelect: onSelectTarget,
            onChange: _cache[4] || (_cache[4] = ($event: any) => (editTemplate('target', $event)))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_multiselect_text, {
            modelValue: chronorder.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((chronorder).value = $event)),
            options: chronorderList,
            "allow-empty": true,
            taggable: false,
            multiple: "",
            onSelect: onSelectChronorder,
            onChange: _cache[6] || (_cache[6] = ($event: any) => (editTemplate('chronorder', $event)))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: "form-control",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((daysbefore).value = $event))
          }, null, 512), [
            [_vModelText, daysbefore.value]
          ])
        ]),
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_singleselect_text, {
            modelValue: managedtype.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((managedtype).value = $event)),
            options: managedtypeOptions
          }, _createSlots({ _: 2 }, [
            (managedtype.value)
              ? {
                  name: "clear",
                  fn: _withCtx(() => [
                    _createElementVNode("i", {
                      onMousedown: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (managedtype.value = ''), ["prevent","stop"])),
                      class: "multiselect__clear fa fa-times",
                      "aria-label": "Clear"
                    }, null, 32)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_unref(DxSwitch), {
                value: defaulttemplate.value,
                onValueChanged: _cache[10] || (_cache[10] = ($event: any) => (setSMSTemplateDeep({path: 'defaulttemplate', data: $event.value})))
              }, null, 8, ["value"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_ckeditor, {
            editor: bodyeditor.value,
            modelValue: body.value,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((body).value = $event)),
            config: bodyEditorConfig.value
          }, null, 8, ["editor", "modelValue", "config"])
        ])
      ])
    ])
  ]))
}
}

})